const REACT_APP_BASE_DEV = "http://localhost:5000";

function trimTrailingSlash(value = "") {
  return value.replace(/\/+$/, "");
}

const { origin, hostname } = window.location;

function getConfiguredApiBase() {
  const envProd = trimTrailingSlash(process.env.REACT_APP_BASE_PROD || "");
  const envDev = trimTrailingSlash(process.env.REACT_APP_BASE_DEV || "");

  const isLocalHost = hostname === "localhost" || hostname === "127.0.0.1";

  // 🔹 ALWAYS use local backend when running on localhost
  if (isLocalHost) {
    return envDev || REACT_APP_BASE_DEV;
  }

  // 🔹 Development mode (non-production)
  if (process.env.NODE_ENV !== "production") {
    return envDev || REACT_APP_BASE_DEV;
  }

  // 🔹 Production mode
  if (envProd) {
    return envProd;
  }

  // 🔹 Fallback: same domain (reverse proxy)
  return `${trimTrailingSlash(origin)}/api`;
}

const BASE_API = getConfiguredApiBase();

export const API = {
  PARSE_RESUME: `${BASE_API}/parse`,
  GENERATE_PDF: `${BASE_API}/generate-pdf`,
  GENERATE_COVER_LETTER: `${BASE_API}/generate-pdf`,
  GENERATE_DOCX: `${BASE_API}/generate-docx`,
  SAVE_IN_STORE: `${BASE_API}/save-in-store`,
  GET_STORED_FILES: `${BASE_API}/getstoredfiles`,
  PREVIEW_PDF: `${BASE_API}/preview-pdf`,
  START_PAYMENT: `${BASE_API}/start-payment`,
  VERIFY_PAYMENT: `${BASE_API}/verify-payment`,
  PAYMENT_STATUS: `${BASE_API}/payment-status`,
  SUBSCRIPTION_STATUS: `${BASE_API}/subscription-status`,
  PAYMENT_HISTORY: `${BASE_API}/payment-history`,
};


export { BASE_API };
